<template>
  <div class="order">

    <div class="container order-container has-text-centered" v-if="currentUserId">


      <div class="card" :class="{'order-card-active' : orderCardActive, 'order-card' : !orderCardActive}">
        <div class="card-content">
          <h5 class="title is-5">Pilot<span class="icon" v-if="orderCardActive"><i class="fas fa-check" id="order-selected"></i></span></h5>

          <div id="order-cost" class="has-text-centered">kr 350 <a id="order-muted">/mnd</a></div>
          <br>
          <ul>
            <li id="list-item">23 gruppetimer hver uke</li>
            <li id="list-item">Tren så mye du vil</li>
            <li id="list-item">Ingen bindingstid</li>
          </ul>

          <div class="has-text-centered" id="btn-blimedlem-meta">
            <a @click="cardFormHidden = false; orderCardActive = true" class="button is-primary" id="btn-blimedlem">Velg</a>
          </div>
        </div>
      </div>


      <div class="continer card-form-container">

        <form action="/charge" method="post" id="payment-form" :class="{'is-hidden' : cardFormHidden}">
          <div class="form-row">

            <label for="card-element">

            </label>

            <div id="card-element">
              <!-- A Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display form errors. -->
            <div id="card-errors" role="alert"></div>


            <button @click="checkSending = true" id="pay-btn"><span v-if="checkSending"><i class="fa fa-btn fa-spinner fa-spin"></i></span><div v-if="!checkSending">Betal</div></button>


          </div>
        </form>
      </div>
    </div>


  </div>
</template>

<script src="https://js.stripe.com/v3/"></script>

<script>

var stripe = Stripe('pk_live_mqs1iML6aWzdN5Xch8VotdQC');
var elements = stripe.elements({
  locale: 'no',
  family: 'Roboto',
});

var style = {
  base: {
    color: '#32325d',
    lineHeight: '18px',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};
// Create an instance of the card Element.
var card = elements.create('card', {style: style});


card.addEventListener('change', function(event) {
  var displayError = document.getElementById('card-errors');
  if (event.error) {
    displayError.textContent = event.error.message;
  } else {
    displayError.textContent = '';
  }
});

import Firebase from 'firebase';

// Token is created using Checkout or Elements!
// Get the payment token ID submitted by the form:

function newStripeCharge(form){
  var currentUser = Firebase.auth().currentUser;
  var sourceId = Firebase.database().ref(`/users/${currentUser.uid}/stripe_id/sources/`).push().key;
  Firebase.database().ref(`/users/${currentUser.uid}/stripe_id/sources/${sourceId}`).set({
    token: form
  });
  window.location.replace('https://combine.no/'+'order-complete/'+sourceId);
};



//import { chargeCard } from './server.js'


export default {
  data () {
    return {
      currentUserId: '',
      checkSending: false,
      charges: '',
      charge: '',
      paymentId: '',
      cardFormHidden: true,
      orderCardActive: false,

    }
  },
  methods: {

  },
  mounted(){
    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');

    var form = document.getElementById('payment-form');

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      // Create a token or display an error when the form is submitted.
      stripe.createToken(card).then(function(result) {
        if (result.error) {
          // Inform the user if there was an error.
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server.
          //newStripeCharge(result.token);

          var hiddenInput = document.createElement('input');
          hiddenInput.setAttribute('type', 'hidden');
          hiddenInput.setAttribute('name', 'stripeToken');
          hiddenInput.setAttribute('value', result.token.id);
          form.appendChild(hiddenInput);

          var currentUser = Firebase.auth().currentUser;

          /*  var sourceId = Firebase.database().ref(`/users/${currentUser.uid}/stripe_id/sources/`).push().key;
          Firebase.database().ref(`/users/${currentUser.uid}/stripe_id/sources/${sourceId}`).set({
          token: result.token
        });*/
        var sourceId = Firebase.database().ref(`/users/${currentUser.uid}/charges/`).push().key;
        console.log(sourceId);
        Firebase.database().ref(`/users/${currentUser.uid}/charges/${sourceId}`).set({
          token: result.token
        });

        window.location.replace('https://combine.no'+'/order-complete/'+sourceId);
      }
    });
  });

},

created: function(){
  var currentUserUID = Firebase.auth().currentUser.uid;

  Firebase.database().ref('/users/'+currentUserUID+'/hasPaid/').on('value', snapshot => {
    var hasPaid = snapshot.val();
    if(hasPaid) {
      window.location.replace('https://combine.no/'+'user');
    }
  });

  this.currentUserId = currentUserUID;
  Firebase.database().ref('/stripe_customers/'+currentUserUID+'/charges').on('value', snapshot => {
    this.charges = snapshot.val();
  });

  //if(this.charges !== null){
  //this.$router.push({path: 'order-complete/'+currentUserUID});
  //  }
},
methods: {

}
}

</script>

<style>

.order{
  padding-top: 150px;
  background-color: #F5F7F9;
  height: 1000px;
}

/**
* The CSS shown here will not be introduced in the Quickstart guide, but shows
* how you can use CSS to style your Element's container.
*/
.StripeElement {
  width: 500px;
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.card-form-container{
  padding-top: 50px;
  justify-content: center;

}
#card-element{
  margin: auto;
  margin-bottom: 12px;
}
#pay-btn{
  color: white;
  background-color: #33325D;
  font-family: 'Roboto';
  display: inline;
  width: 31em;
  height: 40px;
  border-radius: 4px;
  font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  border: 1px solid transparent;

}
#pay-btn:hover{
  background-color: #514FAB;
  transform: translateY(-1px);
  transition: 0.2s;
}
#pay-form{
  display: inline-block;
}
#pay-btn-column{
  margin-left: 50px;
}

.order-card{
  max-width: 355px;
  justify-content: center;
  display: inline-block;
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.order-card:hover{
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}
.order-card-active{
  max-width: 355px;
  justify-content: center;
  display: inline-block;
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.2);
  border-width: 20px;
  border-color: #e6ebf1;
  border-radius: 4px;
  transition: 0.3s;
}

#order-cost{
  font-size: 22px;
}
#order-muted{
  font-size: 18px;
  color: grey;
}
#order-selected{
  color: #15C0BA;
  transition: 0.4s;
}
#btn-blimedlem-meta{
  padding-top: 15px;
}
#btn-blimedlem{
  width: 110px;
  height: 50px;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Order.vue